var app = angular.module("leonardo");

var WorkOrderValues = function($scope, $state, ngDialog, PermissionService, AuthDataService, FilterService,
                               $controller, $q, WorkOrderCVService) {

  $scope.authDataService = AuthDataService;
  $scope.platform = {};
  $scope.custom_type = {};

  $scope.values = [];

  $scope.title = '';

  $scope.getValueType = function () {
    return $scope.platform.name + ' - Work Order ' + $scope.custom_type.name;
  };

  $scope.isSystem = function (value) {
    return isNull(value.account) && isEmpty(value.properties);
  };

  $scope.isEditable = function (value) {
    if (value.editable === false) {
      return false;
    }
    if ($scope.isSystem(value)) {
      return (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin());
    }
    else {
      return PermissionService.isOwnerByAccount(value.account);
    }
  };

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    options['summary'] = true;
    options['search'] = FilterService.getFilter('search');
    options['client_instance'] = FilterService.getFilter('client_instances', true);
    options['pms_platform'] = FilterService.getFilter('pms_platform');
    options['type'] = FilterService.getFilter('custom_type');
    WorkOrderCVService.getlist(options).then(function (data) {
      $scope.values = data.results ? data.results : data;
      $scope.title = $scope.getValueType();
      defer.resolve(data);
    });
    return defer.promise;
  };

  $scope.showItemDeleteDialog = function(value) {
    WorkOrderCVService.get(value.id).then(function(data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'custom value',
        }
      }).then(function(){
        WorkOrderCVService.updateCollection(value, true);
        $scope.loadPage($scope.page);
      });
    });
  };

  $scope.showCloneAdminDialog = function (value, type) {
    WorkOrderCVService.get(value.id).then(function(data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/admin/clone-element.html',
        controller: 'CloneTypeDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          onlyClientInstance: true,
          type: type,
        }
      }).then(function (result) {
        if (result.type_result === 'client_instance') {
          data.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
            $scope.loadPage($scope.page);
          });
        }
      });
    });
  };

  $scope.goToWorkOrderValueEdit = function (value) {
    $state.go('work-orders.custom-values.edit', {pk: value.id});
  };

  $scope.$on('pms_platform:updated', function (event, platform) {
    $scope.platform = platform;
  });

  $scope.$on('custom_type:updated', function (event, type) {
    $scope.custom_type = type;
  });

  $controller('TableFilterController', {$scope: $scope});

};

app.controller('WorkOrderValues', ['$scope', '$state', 'ngDialog', 'PermissionService', 'AuthDataService',
  'FilterService', '$controller', '$q', 'WorkOrderCVService', WorkOrderValues]);
